module.exports = __webpack_public_path__ + "img/iran.36bb1b7d.svg";